import { createAsyncThunk } from '@reduxjs/toolkit';

import { adaptBrowseFilters } from 'src/redux/products/adapters/browse-data-api/adaptBrowseFilters';
import { adaptBrowseProducts } from 'src/redux/products/adapters/browse-data-api/adaptBrowseProducts';
import { adaptBrowseSortOptions } from 'src/redux/products/adapters/browse-data-api/adaptBrowseSortOptions';

export const healthCheckProducts = createAsyncThunk('products/healthCheck', async () => {
  // Dynamically import json file to prevent it being included on the client. Healthcheck request only happens server side.
  const { healthCheckCategoryResponseBody } = await import(
    'src/services/browse-data-api/fixtures/healthCheckCategoryResponseBody'
  );

  return {
    filters: adaptBrowseFilters(healthCheckCategoryResponseBody.filters),
    products: adaptBrowseProducts(healthCheckCategoryResponseBody),
    sortOptions: adaptBrowseSortOptions(healthCheckCategoryResponseBody.sortingOptions),
  };
});
